module.exports = __webpack_public_path__ + "img/symfony_black_03.f27119c2.png";